import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Mic2, Brain, BookOpen, LineChart } from "lucide-react";

const ITEMS = [
  { to: "/dashboard", label: "Today", icon: Home, end: true },
  { to: "/dashboard/session", label: "Session", icon: Mic2 },
  { to: "/dashboard/memory", label: "Memory", icon: Brain },
  { to: "/dashboard/practice", label: "Practice", icon: BookOpen },
  { to: "/dashboard/progress", label: "Stats", icon: LineChart },
];

const MobileNav = () => (
  <div
    className="lg:hidden fixed bottom-0 inset-x-0 z-30 border-t border-panel/8 bg-elev/90 backdrop-blur-xl"
    data-testid="mobile-bottom-nav"
  >
    <div className="grid grid-cols-5">
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          data-testid={`mobile-nav-${item.label.toLowerCase()}`}
          className={({ isActive }) =>
            `flex flex-col items-center gap-1 py-2.5 ${isActive ? "text-ink" : "text-whisper-muted"}`
          }
        >
          {({ isActive }) => (
            <>
              <span className={`w-8 h-8 rounded-lg grid place-items-center ${isActive ? "bg-aura-cyan/15 text-aura-cyan" : ""}`}>
                <item.icon size={16} strokeWidth={1.6} />
              </span>
              <span className="font-mono text-[9px] tracking-[0.18em] uppercase">{item.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </div>
  </div>
);

export default MobileNav;
